import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';

export type SearchPillProps = PropsWithChildren<{
  onClick?: () => void;
  icon?: SvgComponent;
}>;

export const PillBase = styled.button<SearchPillProps>`
  display: flex;
  align-items: center;
  gap: ${theme.spacings[2].rem};
  width: fit-content;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid ${theme.colors.neutrals.solidGrays[5]};
  border-radius: ${theme.borderRadius.rounded};
  padding: ${theme.spacings[2].rem} ${theme.spacings[4].rem};
  background-color: ${theme.colors.primary.white};
  color: ${theme.colors.neutrals.solidGrays[1]};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${theme.colors.primary.graysRed};
  }

  &:active,
  &:focus,
  &:focus-visible {
    background-color: ${theme.colors.primary.graysRed};
  }

  &:active p,
  &:focus p,
  &:focus-visible p {
    color: ${theme.colors.primary.white};
  }

  &:active svg,
  &:focus svg,
  &:focus-visible svg {
    fill: ${theme.colors.primary.white};
  }
`;

export const SearchPill: React.FC<SearchPillProps> = ({
  icon: Icon,
  onClick,
  children,
}) => (
  <PillBase onClick={onClick}>
    {Icon && <Icon width={24} />}
    <UIText size="sm">{children}</UIText>
  </PillBase>
);
